import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { useT } from '../../i18n';

export function MessagePage({ icon: Icon, title, body }: { icon: LucideIcon; title: string; body?: string }) {
  const t = useT();
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center py-16 text-center" data-testid="message-page">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-soft text-slate-800">
        <Icon className="h-8 w-8" />
      </span>
      <h1 className="mt-6 text-2xl font-bold tracking-tight text-slate-900" data-testid="message-title">{title}</h1>
      {body && <p className="mt-2 text-slate-600">{body}</p>}
      <Link to="/" data-testid="message-home-link" className="mt-8 inline-flex h-12 items-center rounded-2xl bg-sc-teal px-6 font-semibold text-white hover:bg-sc-teal-hover">
        {t('common.backHome')}
      </Link>
    </div>
  );
}
